import type { GiftPassBookingRef } from '../../api/gift-passes';

import { bookingWorkshopLine } from './gift-passes-model';
import { GiftPassBookingLink } from './GiftPassBookingLink';

export function GiftPassBookingValue({ booking }: { booking: GiftPassBookingRef }) {
  return (
    <>
      <GiftPassBookingLink id={booking.id} reference={booking.reference} />
      <span style={{ color: 'var(--nb-subtle)' }}> · {bookingWorkshopLine(booking)}</span>
    </>
  );
}
